import creditCardParameters from "../datasets/credit_card_parameters";
import checkIfCreditCardEligible from "./check_if_credit_card_eligible";

export const checkIfEligibleForUnlockedFeature = (gameMonthsPlayed, cashAmt, monthlyIncome,
    annualSalary, unlockedFeatureCriteria, unlockedFeatureGame, creditReport) => {
    //  unlockedFeatureCriteria are the parameters for this unlocked feature
    //  unlockedFeatureGame is the current unlocked feature object from the game
    let eligibleForFeature = false;
    let featureName = unlockedFeatureCriteria.featureName; 
    let creditCardCheck = false;
    if (featureName === "creditCard"){
        let creditIndx = 0;
        if (unlockedFeatureGame){
            creditIndx = unlockedFeatureGame.level;
        }
        if (creditCardParameters[creditIndx]){
            const maxCreditAmt = creditCardParameters[creditIndx].maxCreditCardAmt;
            const creditCardCheckObj = checkIfCreditCardEligible(annualSalary, maxCreditAmt, creditReport);
            creditCardCheck = creditCardCheckObj.creditCardAuthorization; 
        }
    }else{
        creditCardCheck = true;
    }
    if (gameMonthsPlayed >= unlockedFeatureCriteria.minNbrMonths &&
        cashAmt >= unlockedFeatureCriteria.minCashAmt &&
        monthlyIncome >= unlockedFeatureCriteria.minMonthIncome &&
        creditCardCheck === true){
            eligibleForFeature = true;
    }
    return eligibleForFeature;
}
export default checkIfEligibleForUnlockedFeature;